import { useMutation } from '@apollo/client';

import {
  SpeakerRequestInput,
  BecomeSpeakerMutation,
  BecomeSpeakerMutationVariables,
} from 'graphql/types';

import BECOME_SPEAKER_MUTATION from 'graphql/speaker/mutations/becomeSpeaker.graphql';

export const useRegistration = () => {
  const [doRegistration, { loading: becomeSpeakerLoading }] = useMutation<
    BecomeSpeakerMutation,
    BecomeSpeakerMutationVariables
  >(BECOME_SPEAKER_MUTATION);

  const registerSpeaker = (input: SpeakerRequestInput) =>
    doRegistration({
      variables: {
        input,
      },
      refetchQueries: ['Me'],
    });

  return {
    registerSpeaker,
    becomeSpeakerLoading,
  };
};
